export interface AppConfig {
  production: boolean;
  apiBaseUrl: string;
  userManagementBaseUrl: string;
  wsUrl: string;
  endpoints: {
    auth: {
      info: string;
      login: string;
      logout: string;
      resetPassword: string;
      changePassword: string;
      accountPublic: string;
      registration: string;
    };
  };
}

const REQUIRED_NON_EMPTY_PATHS: readonly string[] = [
  'endpoints.auth.info',
  'endpoints.auth.login',
  'endpoints.auth.logout',
  'endpoints.auth.resetPassword',
  'endpoints.auth.changePassword',
  'endpoints.auth.accountPublic',
  'endpoints.auth.registration',
  'userManagementBaseUrl',
];

const REQUIRED_OPTIONAL_EMPTY_PATHS: readonly string[] = ['apiBaseUrl', 'wsUrl'];

const REQUIRED_BOOLEAN_PATHS: readonly string[] = ['production'];

function readPath(source: unknown, path: string): unknown {
  return path.split('.').reduce<unknown>((acc, key) => {
    if (acc !== null && typeof acc === 'object') {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, source);
}

export function validateAppConfig(raw: unknown): AppConfig {
  if (raw === null || typeof raw !== 'object') {
    throw new Error('[Config] config.json non è un oggetto valido.');
  }

  const missing: string[] = [];

  for (const path of REQUIRED_BOOLEAN_PATHS) {
    if (typeof readPath(raw, path) !== 'boolean') {
      missing.push(`${path} (boolean atteso)`);
    }
  }

  for (const path of [...REQUIRED_OPTIONAL_EMPTY_PATHS, ...REQUIRED_NON_EMPTY_PATHS]) {
    const value = readPath(raw, path);
    if (typeof value !== 'string') {
      missing.push(`${path} (string attesa)`);
    } else if (REQUIRED_NON_EMPTY_PATHS.includes(path) && value.trim() === '') {
      missing.push(`${path} (stringa vuota non ammessa)`);
    }
  }

  if (missing.length > 0) {
    throw new Error(`[Config] config.json non valido — chiavi mancanti: ${missing.join(', ')}`);
  }

  return raw as AppConfig;
}
